// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

* {
  margin: 0;
  padding: 0;
}

.app-container {
  display: flex;
  transition: width 0.5s ease;
}

.app-container.sidebar-visible .body-image {
  width: 80%;
  margin-left: 20%;
}

.app-container.sidebar-hidden .body-image {
  width: 100%;
}

.body-image {
  /* background-image: url('assets/img/vt-stacked-official.jpg'); */
  background-size: 20%;
  background-position: left bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
}

.body-image-2 {
  /* background-image: url('assets/img/CARNATIONS text logo.png'); */
  background-size: 25%;
  background-position: right bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
}

.pages {
  color: #316685;
  text-align: center;
  font-size: 3.5rem;
  /* margin-top: 10%; */
}

.pages-container {
  width: 100%; /* Set the width to 100% of the viewport width */
  /*height: 120vh; /* Set the height to 100% of the viewport height */
  min-height: 850px;
  height: auto;
  display: flex; /* Optionally, use flexbox for layout */
  justify-content: center; /* Center content horizontally */
  align-items: left; /* Center content vertically */
}
@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,oBAAoB;EACpB,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kEAAkE;EAClE,oBAAoB;EACpB,iCAAiC;EACjC,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW,EAAE,gDAAgD;EAC7D,mEAAmE;EACnE,iBAAiB;EACjB,YAAY;EACZ,aAAa,EAAE,uCAAuC;EACtD,uBAAuB,EAAE,gCAAgC;EACzD,iBAAiB,EAAE,8BAA8B;AACnD;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\n.app-container {\n  display: flex;\n  transition: width 0.5s ease;\n}\n\n.app-container.sidebar-visible .body-image {\n  width: 80%;\n  margin-left: 20%;\n}\n\n.app-container.sidebar-hidden .body-image {\n  width: 100%;\n}\n\n.body-image {\n  /* background-image: url('assets/img/vt-stacked-official.jpg'); */\n  background-size: 20%;\n  background-position: left bottom;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: auto;\n}\n\n.body-image-2 {\n  /* background-image: url('assets/img/CARNATIONS text logo.png'); */\n  background-size: 25%;\n  background-position: right bottom;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: auto;\n}\n\n.pages {\n  color: #316685;\n  text-align: center;\n  font-size: 3.5rem;\n  /* margin-top: 10%; */\n}\n\n.pages-container {\n  width: 100%; /* Set the width to 100% of the viewport width */\n  /*height: 120vh; /* Set the height to 100% of the viewport height */\n  min-height: 850px;\n  height: auto;\n  display: flex; /* Optionally, use flexbox for layout */\n  justify-content: center; /* Center content horizontally */\n  align-items: left; /* Center content vertically */\n}\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
